<template>
    <div class="feature-icon-list">
        <div class="row">
            <div class="col-lg-6">
                <div class="feature-icon-list__media wow move-up">
                    <img src="../assets/img/features/aeroland-branding-image-10.png" class="img-fluid" alt="" loading="lazy">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="feature-icon-list__content">
                    <div class="feature-icon-list-wrapper">
                        <div v-for="feature in features" :key="feature.id" class="single-feature-icon wow move-up">
                            <div class="single-feature-icon__media">
                                <img :src="feature.icon" class="img-fluid" alt="" loading="lazy">
                            </div>
                            <div class="single-feature-icon__content">
                                <h6 class="title">{{ $t(feature.title) }}</h6>
                                <div class="text">{{ $t(feature.desc) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'featureList',
        data (){
            return {
                features: [
                    {
                        icon: require('../assets/img/icons/aeroland-branding-box-image-01-1.png'), 
                        title:"kullanicidostu", 
                        desc: 'kullanicidostuslogan'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-branding-box-image-02-1.png'), 
                        title: 'yuksekduyarliaraclar', 
                        desc: 'yuksekduyarliaraclarslogan'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-branding-box-image-03-1.png'), 
                        title: 'mobiluyumlu', 
                        desc: 'mobilslogan'
                    },
                ]
            }
        }
    }
</script>
